import React from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import I10n from '../../../features/i10n';
import MsxIcons from "../../msx-icons";
import { SECONDARY_COLOR } from "../../../color-constants";
import ModalWrapper from "../../../atoms/modal-wrapper";
import { LICENSE_MODELS, LICENSE_SELECTOR_SOFTWARES, softwareStepsConfig } from "../../../constants";
import SoftwareSelectionScreen from "./software_selection_screen";
import ServicePlanScreen from "./service_plan_screen";
import { setHardwareToSoftwareSelection, setSoftwareSelection } from "../../configuration-management/ducks";
import LicenceSelectorScreen from "./licence_selector_screen";
import LicenceSelectorScreenV2 from "./licence_selector_screen_v2";
import { buildNewSoftwareLicenses, removeSoftwareLicenceHelper, setSoftwareLicenceQuantityHelper } from "../../configuration-management/utils";

const Container = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  height: calc(100vh - 4em);
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  background-color: white;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: stretch;
  background-color: rgb(244, 244, 244);
  border-top: 2px solid #cccc;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

class ModalHardwareToSoftware extends React.PureComponent {

  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      softwareSelectionStep: softwareStepsConfig.software_selection,
      softwareSelection: null,
      licenseModel: LICENSE_MODELS.PERPETUAL,
      softwareLicences: [],
      servicePlanActivated: true
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  updateStateIfMounted(objectToAffect) {
    if (this._isMounted) {
      this.setState(objectToAffect);
    }
  }

  retrieveStepFromMapping = (stepsMapping, stepId) => {
    let component = <></>;
    const mapped = stepsMapping[stepId];
    if (mapped) {
      component = mapped();
    }
    return component;
  }

  buildLicensesToAdd = (licensesToAdd, licenceType) => {
    const newLicenses = (licensesToAdd || []).map(license => {
      return {...license.softwareLicence, quantity: license.quantity};
    });
    return buildNewSoftwareLicenses(this.state.softwareLicences, newLicenses, licenceType)
  }

  transmitLicensesPayload = () => {
    this.props.closeModal();
    this.props.setHardwareToSoftwareSelection(
      this.state.softwareSelection.key,
      this.state.licenseModel,
      this.state.softwareLicences,
      this.state.servicePlanActivated);
  }

  hasServicePlanItems = () => {
    const candidateServicePlans = this.state.softwareSelection.servicePlanItems || [];
    return candidateServicePlans.length > 0 && candidateServicePlans
      .filter(item => item.licenseModel === this.state.licenseModel).length > 0;
  }

  getSoftwaresToFilter = () => {
    return (this.props.configuration.hardwareToSoftwareCompatibilities || [])
      .map(compatibility => {
        return compatibility.softwareKey;
      });
  }

  getHardwareToSoftwareCompatibiliesForSpecificSoftware= () => {
    return (this.props.configuration.hardwareToSoftwareCompatibilities || [])
      .filter(compatibility => {
        return compatibility.softwareKey === this.state.softwareSelection.key;
      });
  }

  renderActiveStep = () => {
    const stepsMapping = {
      [softwareStepsConfig.software_selection]: () => <SoftwareSelectionScreen
        setSoftwareSelection={(softwareSelection) => {
          if (softwareSelection !== this.state.softwareSelection) {
            this.updateStateIfMounted({softwareSelection,
              softwareLicences: [],
              softwareSelectionStep: softwareStepsConfig.licence_selector,
              licenseModel: LICENSE_MODELS.PERPETUAL,
            });
          } else {
            this.updateStateIfMounted({
              softwareSelectionStep: softwareStepsConfig.licence_selector,
              licenseModel: LICENSE_MODELS.PERPETUAL,
            });
          }
        }}
        softwaresToShow={this.getSoftwaresToFilter()}
      ></SoftwareSelectionScreen>,
      [softwareStepsConfig.licence_selector]: () => {
        if (this.state.softwareSelection.key === LICENSE_SELECTOR_SOFTWARES.CONTROL_EXPERT) {
          return (<LicenceSelectorScreen
            softwareSelection={this.state.softwareSelection.key}
            licenseModel={this.state.licenseModel}
            addSoftwareLicences={(licencesToAdd, licenceType) => {
              const newState = {
                softwareLicences: this.buildLicensesToAdd(licencesToAdd, licenceType)
              };
              this.updateStateIfMounted(newState);
            }}
            removeSoftwareLicence={(license) => {
              this.updateStateIfMounted({
                softwareLicences: removeSoftwareLicenceHelper(this.state.softwareLicences, license)
              });
            }}
            setSoftwareLicenceQuantity={(license, newQuantity) => {
              this.updateStateIfMounted({
                softwareLicences: setSoftwareLicenceQuantityHelper(this.state.softwareLicences, license, newQuantity)
              });
            }}
            softwareLicences={this.state.softwareLicences}
            onContinue={() => {
              if (this.hasServicePlanItems()) {
                this.updateStateIfMounted({
                  softwareSelectionStep: softwareStepsConfig.service_plan
                });
              } else {
                this.transmitLicensesPayload();
              }
            }}
            onPrevious={() => {
              this.updateStateIfMounted({
                softwareSelectionStep: softwareStepsConfig.software_selection
              });
            }}
            hardwareToSoftwareCompatibilities={this.getHardwareToSoftwareCompatibiliesForSpecificSoftware()}
          ></LicenceSelectorScreen>);
        }
        return (<LicenceSelectorScreenV2
          softwareSelection={this.state.softwareSelection.key}
          licenseModel={this.state.licenseModel}
          softwareLicences={this.state.softwareLicences}
          setLicenseModel={(newLicenceModel) => {
            this.updateStateIfMounted({
              licenseModel: newLicenceModel,
              softwareLicences: []
            });
          }}
          addSoftwareLicenses={(licencesToAdd, licenceType, withNavigation) => {
            const newState = {
              softwareLicences: this.buildLicensesToAdd(licencesToAdd, licenceType)
            };

            if (withNavigation) {
              if (this.hasServicePlanItems()) {
                newState.softwareSelectionStep = softwareStepsConfig.service_plan;
              } else {
                this.transmitLicensesPayload();
              }
            }

            this.updateStateIfMounted(newState);
          }}
          removeSoftwareLicence={(license) => {
            this.updateStateIfMounted({
              softwareLicences: removeSoftwareLicenceHelper(this.state.softwareLicences, license)
            });
          }}
          onContinue={() => {
            if (this.hasServicePlanItems()) {
              this.updateStateIfMounted({
                softwareSelectionStep: softwareStepsConfig.service_plan
              });
            } else {
              this.transmitLicensesPayload();
            }
          }}
          onPrevious={() => {
            this.updateStateIfMounted({
              softwareSelectionStep: softwareStepsConfig.software_selection
            });
          }}
          hardwareToSoftwareCompatibilities={this.getHardwareToSoftwareCompatibiliesForSpecificSoftware()}
        >
        </LicenceSelectorScreenV2>);
      },
      [softwareStepsConfig.service_plan]: () => <ServicePlanScreen
          softwareInfo={this.state.softwareSelection}
          licenseModel={this.state.licenseModel}
          softwareLicences={this.state.softwareLicences}
          servicePlanActivated={this.state.servicePlanActivated}
          clearSoftwareLicenses={() => {
            this.updateStateIfMounted({
              softwareLicences: [],
              softwareSelectionStep: softwareStepsConfig.licence_selector
            });
          }}
          removeSoftwareLicence={(license) => {
            this.updateStateIfMounted({
              softwareLicences: removeSoftwareLicenceHelper(this.state.softwareLicences, license)
            });
          }}
          setServicePlanActivation={(newStatus) => {
            this.updateStateIfMounted({
              servicePlanActivated: newStatus
            });
          }}
          onContinue={() => {
            this.transmitLicensesPayload();
          }}
          onPrevious={() => {
            this.updateStateIfMounted({
              softwareSelectionStep: softwareStepsConfig.licence_selector
            });
          }}
        >
        </ServicePlanScreen>,
    };
    return this.retrieveStepFromMapping(stepsMapping, this.state.softwareSelectionStep);
  }

  render = () => {
    return (
      <ModalWrapper>
        <Container>
          <Header>
            <TitleWrapper>
              <Title>{I10n.get('screen.accessorize_screen.license_configuration')}</Title>
              <CloseIcon onClick={(e) => {
                e.preventDefault();
                this.props.closeModal();
              }}>
                <MsxIcons name="close"></MsxIcons>
              </CloseIcon>
            </TitleWrapper>
          </Header>
          <Body>
            {this.renderActiveStep()}
          </Body>
        </Container>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = state => {
  return state;
};

const mapDispatchToProps = dispatch => {
  return {
    setSoftwareSelection: (softwareSelection, step) => dispatch(setSoftwareSelection(softwareSelection, step)),
    setHardwareToSoftwareSelection: (softwareSelection, newLicenceModel, licenses, servicePlanActivationStatus) => dispatch(setHardwareToSoftwareSelection(softwareSelection, newLicenceModel, licenses, servicePlanActivationStatus))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalHardwareToSoftware);
